import { log } from "../utils/log.js";

var WebSocketClient = /*#__PURE__*/function () {
  /**
   * @param {string} url
   */
  function WebSocketClient(url) {
    _classCallCheck(this, WebSocketClient);
    try {
      // שינוי ה-URL מ-wss:// ל-ws://
      if (url.startsWith('wss://')) {
        url = 'ws://' + url.substring(6);
        log.info("שינוי חיבור מאובטח לרגיל: " + url);
      }
      
      this.client = new WebSocket(url);
      this.client.onerror = function (error) {
        log.error("שגיאת WebSocket: ", error);
      };
    } catch (error) {
      log.error("שגיאה ביצירת חיבור WebSocket: ", error);
    }
  }
  
  /**
   * @param {(...args: any[]) => void} f
   */
  _createClass(WebSocketClient, [{
    key: "onOpen",
    value: function onOpen(f) {
      this.client.onopen = f;
    }
    /**
     * @param {(...args: any[]) => void} f
     */
  }, {
    key: "onClose",
    value: function onClose(f) {
      this.client.onclose = f;
    }
    // call f with the message string as the first argument
    /**
     * @param {(...args: any[]) => void} f
     */
  }, {
    key: "onMessage",
    value: function onMessage(f) {
      this.client.onmessage = function (e) {
        f(e.data);
      };
    }
    
    /**
     * שולח הודעה לשרת
     * @param {string|object} data - הנתונים לשליחה
     */
  }, {
    key: "send",
    value: function send(data) {
      if (this.client && this.client.readyState === WebSocket.OPEN) {
        // המרת אובייקטים ל-JSON לפני שליחה
        if (typeof data === 'object') {
          data = JSON.stringify(data);
        }
        this.client.send(data);
        return true;
      } else {
        log.error("לא ניתן לשלוח הודעה: החיבור אינו פתוח");
        return false;
      }
    }
    
    /**
     * סוגר את החיבור
     */
  }, {
    key: "close",
    value: function close() {
      if (this.client) {
        this.client.close();
      }
    }
  }]);
  
  return WebSocketClient;
}();

export { WebSocketClient as default };